import styles from '../../../style.module.scss';
import HintIcon from "../icons/hint-icon";
import {useState} from "react";

const Hint = ({text,fill =null}) => {
    const [open, setOpen] = useState(false)
    const handleClick = () => {
        if (open) {
            setOpen(false);
        } else {
            setOpen(true);
            setTimeout(function () {
                setOpen(false)
            }, 3000)
        }
    }
    const handleMouseOver = () => {
        if (!open) {
            setOpen(true);
        }
    }
    const handleOnMouseOut = () => {
        setTimeout(function () {
            setOpen(false)
        }, 100)
    }
    if (!!text && !!text.length) {
        return (
            <div className={styles.hint} onClick={() => handleClick()} onMouseOver={() => handleMouseOver()}
                 onMouseOut={() => handleOnMouseOut()}>
                <div className={styles.icon}>
                    <HintIcon fill={fill}/>
                </div>
                <div className={`${styles.text} ${open && styles.open}`}>
                    {text}
                </div>
            </div>
        );
    }
    return null;
};

export default Hint;